import { render, staticRenderFns } from "./CalendarClock.vue?vue&type=template&id=56cc931e"
import script from "./CalendarClock.vue?vue&type=script&lang=js"
export * from "./CalendarClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports